import { Component } from '@angular/core'

@Component({
  selector: 'app-check',
  template: ''
})
export class CheckComponent {

}
